import type { AmbleContent } from "..";
import { ambles as affinityriskagentAmbles } from "./affinityriskagent";
import { ambles as agentdemoAmbles } from "./agentdemo";
import { ambles as agenteroAmbles } from "./agentero";
import { ambles as alliantAmbles } from "./alliant";
import { ambles as amazonUsAmbles } from "./amazon_us";
import { ambles as amsuisseAmbles } from "./amsuisse";
import { ambles as amsuisseChambersbayAmbles } from "./amsuisse-chambersbay";
import { ambles as amsuisseGgiausaAmbles } from "./amsuisse-ggiausa";
import { ambles as appulateAmbles } from "./appulate";
import { ambles as appundAmbles } from "./appund";
import { ambles as bunkerprotectAmbles } from "./bunkerprotect";
import { ambles as businessloansAmbles } from "./businessloans";
import { ambles as cnnunderscoredAmbles } from "./cnnunderscored";
import { ambles as collectiveAmbles } from "./collective";
import { ambles as contractorplusAmbles } from "./contractorplus";
import { ambles as cosmopolitanacademyAmbles } from "./cosmopolitanacademy";
import { ambles as ecosystemdemoAmbles } from "./ecosystemdemo";
import { ambles as firstconnectAmbles } from "./firstconnect";
import { ambles as fixebeautyAmbles } from "./fixebeauty";
import { ambles as forbesadvisorAmbles } from "./forbesadvisor";
import { ambles as foundAmbles } from "./found";
import { ambles as gocompareAmbles } from "./gocompare";
import { ambles as hrblockAmbles } from "./hrblock";
import { ambles as letsdeelAmbles } from "./letsdeel";
import { ambles as londonuwAmbles } from "./londonuw";
import { ambles as luxybeautycoursesAmbles } from "./luxybeautycourses";
import { ambles as nantucketlighthouseAmbles } from "./nantucketlighthouse";
import { ambles as newageinsAmbles } from "./newageins";
import { ambles as probeautyAmbles } from "./probeauty";
import { ambles as progressivepocAmbles } from "./progressivepoc";
import { ambles as rocketlawyerAmbles } from "./rocketlawyer";
import { ambles as siaaAmbles } from "./siaa";
import { ambles as siaainsureAmbles } from "./siaainsure";
import { ambles as tarmikaAmbles } from "./tarmika";
import { ambles as thumbtackAmbles } from "./thumbtack";
import { ambles as tivlyagencyAmbles } from "./tivlyagency";
import { ambles as ueniAmbles } from "./ueni";
import { ambles as usapartnernetworkAmbles } from "./usapartnernetwork";
import { ambles as usginsAmbles } from "./usgins";
import { ambles as westhillglobalAmbles } from "./westhillglobal";
import { ambles as westhillglobalpartnerAmbles } from "./westhillglobalpartner";
import { ambles as woocommerceAmbles } from "./woocommerce";
import { ambles as xceleranAmbles } from "./xceleran";

/**
 * Site-specific ambles organized by site name
 */
export const siteAmbles: Record<string, Record<string, AmbleContent>> = {
  affinityriskagent: affinityriskagentAmbles,
  agentdemo: agentdemoAmbles,
  agentero: agenteroAmbles,
  alliant: alliantAmbles,
  amazon_us: amazonUsAmbles,
  amsuisse: amsuisseAmbles,
  "amsuisse-chambersbay": amsuisseChambersbayAmbles,
  "amsuisse-ggiausa": amsuisseGgiausaAmbles,
  appulate: appulateAmbles,
  appund: appundAmbles,
  bunkerprotect: bunkerprotectAmbles,
  businessloans: businessloansAmbles,
  cnnunderscored: cnnunderscoredAmbles,
  collective: collectiveAmbles,
  contractorplus: contractorplusAmbles,
  cosmopolitanacademy: cosmopolitanacademyAmbles,
  ecosystemdemo: ecosystemdemoAmbles,
  firstconnect: firstconnectAmbles,
  fixebeauty: fixebeautyAmbles,
  forbesadvisor: forbesadvisorAmbles,
  found: foundAmbles,
  gocompare: gocompareAmbles,
  hrblock: hrblockAmbles,
  letsdeel: letsdeelAmbles,
  londonuw: londonuwAmbles,
  luxybeautycourses: luxybeautycoursesAmbles,
  nantucketlighthouse: nantucketlighthouseAmbles,
  newageins: newageinsAmbles,
  probeauty: probeautyAmbles,
  progressivepoc: progressivepocAmbles,
  rocketlawyer: rocketlawyerAmbles,
  siaa: siaaAmbles,
  siaainsure: siaainsureAmbles,
  tarmika: tarmikaAmbles,
  thumbtack: thumbtackAmbles,
  tivlyagency: tivlyagencyAmbles,
  ueni: ueniAmbles,
  usapartnernetwork: usapartnernetworkAmbles,
  usgins: usginsAmbles,
  westhillglobal: westhillglobalAmbles,
  westhillglobalpartner: westhillglobalpartnerAmbles,
  woocommerce: woocommerceAmbles,
  xceleran: xceleranAmbles,
};
